import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table table-tenant" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Wallet ID", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, onMounted } from "vue";
import PaymentService from "../services/PaymentService";
import CreateWalletAdjust from "../components/walletAdjust/CreateWalletAdjust.vue";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import { CreateReportSpec } from "@/projects/tenant/services/TenantGlobalService";
import { convertToUTC } from "@/core/utils/DateUtils";

export default /*#__PURE__*/_defineComponent({
  __name: 'WalletAdjust',
  setup(__props) {

const isLoading = ref(false);
const CreateWalletAdjustRef = ref<InstanceType<typeof CreateWalletAdjust>>();
const data = ref(<any>[]);
const criteria = ref<any>({
  page: 1,
  size: 25,
});
const selectedOption = ref("walletId");
const inputValue = ref("");
const period = ref([] as any);
const defaultTime = ref<[Date, Date]>([
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 2, 1, 23, 59, 59),
]);

const formData = ref<CreateReportSpec>({
  name: "",
  type: ReportRequestTypes.SalesRebateForTenant,
  query: criteria.value,
});

const search = () => {
  delete criteria.value.walletId;
  delete criteria.value.email;
  delete criteria.value.partyId;
  criteria.value[selectedOption.value] = inputValue.value;
  fetchData(1);
};

const reset = () => {
  criteria.value = { page: 1, size: 25 };
  period.value = [];
  inputValue.value = "";
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  const datesRange = convertToUTC(period.value);
  criteria.value.from = datesRange.from;
  criteria.value.to = datesRange.to;
  try {
    const res = await PaymentService.getWalletAdjust(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const create = () => {
  CreateWalletAdjustRef.value?.show();
};

// const submitReportRequest = async () => {
//   exporting.value = true;
//   const [from, to] = period.value;
//   const isDST = isDateInDST_US();
//   criteria.value.from = from
//     ? moment(from).format(`YYYY-MM-DD[T]${isDST ? 21 : 22}:00:00.000[Z]`)
//     : null;
//   criteria.value.to = to
//     ? moment(to).format(`YYYY-MM-DD[T]${isDST ? 20 : 21}:59:59.000[Z]`)
//     : null;

//   formData.value.query = criteria.value;

//   try {
//     const media = await TenantGlobalService.createReportRequestDownload(
//       formData.value
//     );
//     await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
//   } catch (error) {
//     MsgPrompt.error(error);
//   } finally {
//     exporting.value = false;
//   }
// };

// watch(
//   () => period.value,
//   (periodVal) => {
//     if (periodVal && periodVal.length > 0 && typeof periodVal[0] !== "string") {
//       periodVal = [
//         moment(periodVal[0]).local().toISOString(),
//         moment(periodVal[1]).local().toISOString(),
//       ];
//     }
//     criteria.value.from = periodVal ? periodVal[0] : null;
//     criteria.value.to = periodVal ? periodVal[1] : null;
//   }
// );

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          modelValue: selectedOption.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
          placeholder: "Select option",
          class: "w-150px me-3",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Wallet ID",
              value: "walletId"
            }),
            _createVNode(_component_el_option, {
              label: "Email",
              value: "email"
            }),
            _createVNode(_component_el_option, {
              label: "Party Id",
              value: "partyId"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_input, {
          class: "w-200px me-3",
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
          disabled: isLoading.value
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_date_picker, {
          class: "w-400px me-3",
          modelValue: period.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period).value = $event)),
          type: "daterange",
          "start-placeholder": _ctx.$t('fields.startDate'),
          "end-placeholder": _ctx.$t('fields.endDate'),
          format: "YYYY-MM-DD",
          "value-format": "YYYY-MM-DD HH:mm:ss"
        }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: search,
          plain: "",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: reset,
          plain: "",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (create()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
            _hoisted_7,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.comment")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_UserInfo, {
                        email: item.email,
                        name: item.nativeName,
                        class: "me-2"
                      }, null, 8, ["email", "name"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.walletId), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_BalanceShow, {
                        balance: item.amount
                      }, null, 8, ["balance"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.comment), 1),
                    _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.createdOn,
                        type: "oneLiner"
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(CreateWalletAdjust, {
      ref_key: "CreateWalletAdjustRef",
      ref: CreateWalletAdjustRef,
      onEventSubmit: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ]))
}
}

})